<template>
  <div class="category-tiles">
    <b-container fluid>
      <b-row>
        <b-col cols="2" />
        <b-col cols="8">
          <div class="card-columns">
            <div v-for="cat in visibleCategories" :key="cat.Oid"
              class="image-tile mb-4 mr-4"
              @click.stop="navTo(cat)"
            >
              <div class="image">
                <img style="aspect-ratio: 1 / 1; width: 100%;" :src="getImage(cat)" />
              </div>
              <div >
                <h4>{{cat.Name}}</h4>
              </div>
            </div>
          </div>
          <!-- <b-card-group deck>
            <b-card v-for="(cat) in visibleCategories" :key="cat.Oid"
              :title="cat.Name"
              :img-src="cat.ImageLink"
              img-height="300"
              img-top
              style=""
              class="flex-card mb-4"
              body-class="centered"
              @click="navTo(cat)"
            >
              <template #footer>
                <span v-for="(item, ind) in cat.VisibleItems" :key="item.Oid">
                  <a href="#" @click.stop="navTo(cat, item)">{{item.Name}}</a>{{(ind == cat.VisibleItems.length - 1 ? '' : ' | ')}}
                </span>
              </template>
            </b-card>
          </b-card-group> -->
          <!-- <div v-for="cat in categories" :key="cat.Oid">
            {{cat.FullName}}
          </div> -->
        </b-col>
        <b-col cols="2" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ConfigService from "@/services/ConfigService";

export default { 
  props: {
    parentCategory: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      categories: [],
      allcats: [],
    };
  },
  created() {
    ConfigService.GetCatalog().then(c => {
      this.allcats = c;
      if(!this.parentCategory) {
        this.categories = c;
      }
      else {
        var cat = c.find(i => i.Name == this.parentCategory);
        if(cat) {
          this.categories = cat.Items;
        }
      }
    })
  },
  watch: {
    parentCategory(val, old) {
      if(val != old) {
        debugger;
        var cat = this.allcats.find(i => i.Name == val);
        if(cat) {
          this.categories = cat.Items;
        }
        // _.forEach(this.allcats, i => {
        //   i.Expanded = (val && _.toUpper(val) === _.toUpper(i.Name));
        // });
      }
    }
  },
  computed: {
    visibleCategories() {
      return this.categories.filter(c => c.Visible);
    }
  },
  methods: {
    getImage(cat) {
      return cat.ImageLink || 'https://placehold.it/300x300';
    },
    getCardStyle(cat) {
      var style = {
        // 'background-size': 'cover',
        // 'aspect-ratio': '1 / 1',
        'cursor': 'pointer'
      };
      // if(cat.ImageLink) {
      //   style['background-image'] = `url(${cat.ImageLink})`;
      // }
      // else {
      //   style['background-image'] = 'url(https://placehold.it/300x300)';
      // }
      return style;
    },
    navTo(cat, subCat) {
      debugger;
      if(subCat) {
        this.$router.push({ name: "CategorySubCategory", params: { category: cat.Name, subcategory: subCat.Name } });
      }
      else if(this.parentCategory) {
        this.$router.push({ name: "CategorySubCategory", params: { category: this.parentCategory, subcategory: cat.Name } });
      }
      else {
        this.$router.push({ name: "Category", params: { category: cat.Name } });
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.flex-card {
  flex: 0 0 auto;
  max-width: 100%;
  min-width: 100%;

  cursor: pointer;
}

h4 {
  font-size: 1.3em;
  text-transform: uppercase;
  text-align: center;
}

.image-tile {  
  position: relative;

  .image-tile-text {
    opacity: 0.75;
    background-color: black;
    color: white;
    text-transform: uppercase;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    font-size: 1.5rem;
    padding-top:5px;
    padding-bottom: 5px;
    text-align: center;
  }
}

.card-columns {
  display: grid; 
  grid-auto-flow: columns; 
  gap: 15px 15px; 
  grid-template-columns: 1fr;
}

@media screen and (min-width: 768px) {
  .card-columns {
    display: grid; 
    grid-auto-flow: columns; 
    gap: 15px 15px; 
    grid-template-columns: 1fr 1fr 1fr;
  }

  .flex-card {
    max-width: 30%;
    min-width: 30%;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Nav/CategoryTiles.vue